import { Card, PhasePill } from "./ui";
import { flag } from "../lib/flag";
import type { WorldElection } from "@shared/types";
import { useI18n } from "../i18n";

// Compact cross-country card for the World feed + Home's mini-world. Lean by
// design — no candidate names (the feed endpoint doesn't fetch them); click
// through to the election for the full forecast.
export function WorldCard({ e, onOpen }: { e: WorldElection; onOpen: () => void }) {
  const { t, locale } = useI18n();
  return (
    <Card className="cursor-pointer hover:border-accent transition">
      <button type="button" className="w-full text-left" onClick={onOpen}>
        <div className="flex justify-between items-start mb-2">
          <div className="flex items-center gap-2 min-w-0">
            <span className="text-lg">{flag(e.countryCode)}</span>
            <div className="min-w-0">
              <div className="font-semibold truncate">{e.countryName}</div>
              <div className="text-xs text-muted capitalize">{e.type === "president" ? t("office.president") : t("office.congress")}</div>
            </div>
          </div>
          <PhasePill phase={e.phase} startsAt={e.votesStartAt} />
        </div>
        <div className="text-xs text-muted">{statusLine(e, t, locale)}</div>
      </button>
    </Card>
  );
}

function statusLine(e: WorldElection, t: ReturnType<typeof useI18n>["t"], locale: string): string {
  const d = (iso: string) => new Date(iso).toLocaleDateString(locale);
  const pct = turnoutPct(e);
  if (e.phase === "live") return t("worldCard.live", { pct, date: d(e.votesEndAt) });
  if (e.phase === "soon") return t("election.opens", { date: d(e.votesStartAt) });
  return t("worldCard.decided", { pct });
}

function turnoutPct(e: WorldElection): number {
  if (e.activePopulation <= 0) return 0;
  return Math.min(100, Math.round((e.votesCount / e.activePopulation) * 1000) / 10);
}
